const ACCESS_KEY = 'accessToken';
const REFRESH_KEY = 'refreshToken';
const PHONE_KEY = 'phone';

export const tokenStorage = {
  save({ access, refresh, phone }: { access: string; refresh: string; phone: string }) {
    localStorage.setItem(ACCESS_KEY, access);
    localStorage.setItem(REFRESH_KEY, refresh);
    localStorage.setItem(PHONE_KEY, phone);
    this.setLoggedIn(true);
    
  },
  getAccess(): string | null {
    return localStorage.getItem(ACCESS_KEY);
  },
  getRefresh(): string | null {
    return localStorage.getItem(REFRESH_KEY);
  },
  setLoggedIn(v: boolean) {
    localStorage.setItem('isLoggedIn', String(v));
  },
  clear() {
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(REFRESH_KEY);
    localStorage.removeItem(PHONE_KEY);
    localStorage.removeItem('isLoggedIn');
  },
};